import { adminApi } from './ApiService';

class TicketService {
  async listTickets(params = {}) {
    return adminApi.get('/admin/tickets', params);
  }

  async getTicketStats() {
    return adminApi.get('/admin/tickets/stats');
  }

  async getTicket(id) {
    return adminApi.get(`/admin/tickets/${id}`);
  }

  async createTicket(data) {
    return adminApi.post('/admin/tickets', data);
  }

  async updateTicket(id, data) {
    return adminApi.patch(`/admin/tickets/${id}`, data);
  }

  async addComment(id, data) {
    return adminApi.post(`/admin/tickets/${id}/comment`, data);
  }

  async deleteTicket(id) {
    return adminApi.delete(`/admin/tickets/${id}`);
  }
}

export const ticketService = new TicketService();
export default ticketService;
